import { useState } from 'react'

const useMenuCC = () => {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    return { open, anchorEl, setAnchorEl }
}

export default useMenuCC